<template>
  <h1>{{ $t('payment_result.success') }}</h1>
</template>

<script>
export default {
  name: 'Success',
};
</script>

<style scoped></style>
